/**
 * Toggle the guided bundle checkout on the product detail page.
 * Set enabled to true to activate the new flow for bundle products.
 */
module.exports = {
  enabled: true,
  presets: {
    premium: {
      skirtKeywords: ['clip'],
      underlayKeywords: ['neolay', 'neo']
    }
  },
  /**
   * Floor-only (Einzelboden) stays implemented, but is hidden until we need it.
   * Set to true to show the third package card again.
   */
  showEinzelboden: false,
  packageOptions: [
    {
      id: 'einzelprodukt',
      label: 'Einzelboden',
      description: 'Nur der Bodenbelag. Leiste und Dämmung kannst du danach optional dazu wählen.',
      requiresEinzelboden: true
    },
    {
      id: 'standard',
      label: 'Standard Set',
      description: 'All-in Set mit kostenloser Standard-Leiste und Standard-Dämmung.'
    },
    {
      id: 'premium',
      label: 'Premium Set',
      description: 'All-in Set mit Aufpreis-Leiste und Premium-Dämmung.'
    }
  ],
  skirtFilterGroups: [
    { id: 'none', label: 'Keine Leiste' },
    { id: 'fuxx', label: 'FUXX', keywords: ['fuxx', 'fußleiste', 'fussleiste'] },
    { id: 'clip', label: 'CLIP', keywords: ['clip'] },
    { id: 'sockel', label: 'Sockel', keywords: ['sockel'] },
    { id: 'weitere', label: 'Weitere' }
  ],
  skirtCategoryOrder: ['clip', 'fuxx', 'sockel'],
  skirtFilterByPreset: {
    einzelprodukt: 'none',
    standard: 'fuxx',
    premium: 'clip'
  },
  skirtMetersPerPack: 2.4,
  /**
   * Magento CMS block identifier for the underlay help modal.
   * Create/edit this block in Magento Admin → Content → Blocks.
   */
  underlayHelpCmsBlock: 'guided-checkout-underlay-help',
  /**
   * Accessory step: products come from Magento "related" links.
   * Groups use Magento category names under the Zubehör root.
   *
   * Production deploy: also link Schienen + Reinigungsmittel + Pflegesets
   * (and later Verlegesets) to all All-in bundles — see
   * theme/docs/guided-checkout-deployment.md
   */
  accessoryLinkType: 'related',
  accessoryExcludeTypZubehoer: [
    223, 225, 227, 229, 231, // Leisten (already in skirt step)
    234 // Dämmung / Unterlagen (already in underlay step)
  ],
  accessoryExcludeNameKeywords: ['muster'],
  /** Magento category "Zubehör" — only categories under this root are used for grouping. */
  accessoryCategoryRootId: 10,
  /** Skip categories already covered by other guided-checkout steps. */
  accessoryExcludeCategoryIds: [
    9, // Abschlussleisten
    30 // Dämmung und Verlegung
  ],
  /**
   * Preferred display order of Magento category IDs (deepest matching category wins).
   * Categories not listed are appended alphabetically.
   */
  accessoryCategoryOrder: [
    32, // Übergangprofile
    124, // Ausgleichprofile
    125, // Einfassprofile
    126, // Winkelprofile
    123, // Abschlussprofile
    29, // Leistenzubehör
    127 // Pflege und Reinigung
  ],
  steps: [
    { id: 'package', label: 'Grundpaket' },
    { id: 'size', label: 'Projektgröße' },
    { id: 'skirt', label: 'Leiste' },
    { id: 'underlay', label: 'Dämmung' },
    { id: 'accessories', label: 'Zubehör' },
    { id: 'fulfillment', label: 'Lieferung' }
  ]
}
